<template>
  <div class="profile-skeleton">
    <div class="layout">
      <aside class="sidebar-skeleton">
        <div class="sk-title"></div>
        <div class="sk-item" v-for="i in 7" :key="i"></div>
      </aside>

      <div class="profile-main">
        <div class="sk-cover"></div>

        <div class="sk-header">
          <div class="sk-avatar"></div>
          <div class="sk-name-block">
            <div class="sk-name"></div>
            <div class="sk-pill"></div>
          </div>
        </div>

        <div class="sk-form">
          <div class="sk-input" v-for="i in 7" :key="i"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
:root {
  --sk-light: linear-gradient(
    90deg,
    #e8e8e8 25%,
    #f4f4f4 50%,
    #e8e8e8 75%
  );

  --sk-dark: linear-gradient(
    90deg,
    #3a3a3a 25%,
    #4a4a4a 50%,
    #3a3a3a 75%
  );
}

html[data-theme="light"], [data-theme="light"] { --sk-bg: var(--sk-light); }
html[data-theme="dark"],  [data-theme="dark"]  { --sk-bg: var(--sk-dark); }

@keyframes shimmer {
  0%   { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}
</style>

<style scoped>
.profile-skeleton {
  min-height: 100%;
}

.layout {
  display: flex;
  max-width: 1440px;
  margin: 0 auto;
  padding: 30px 20px;
}

.sidebar-skeleton {
  width: 260px;
  flex-shrink: 0;
  padding: 24px 16px;
}

.sk-title,
.sk-item,
.sk-cover,
.sk-avatar,
.sk-name,
.sk-pill,
.sk-input {
  background: var(--sk-bg);
  background-size: 200% 100%;
  animation: shimmer 1.2s infinite linear;
  border-radius: 10px;
}

/* левая колонка */
.sk-title {
  height: 18px;
  width: 70%;
  margin-bottom: 18px;
}
.sk-item {
  height: 16px;
  width: 90%;
  margin: 10px 0;
}

/* правая колонка */
.profile-main {
  flex: 1;
  max-width: 800px;
  margin-top: 0;
  margin-left: 20px;
}

.sk-cover {
  height: 180px;
  border-radius: 18px;
  margin-bottom: 20px;
}

.sk-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 0 8px 24px;
}
.sk-avatar {
  width: 90px;
  height: 90px;
  border-radius: 50%;
}
.sk-name-block { flex: 1; }
.sk-name {
  height: 22px;
  width: 40%;
  margin-bottom: 10px;
}
.sk-pill {
  height: 20px;
  width: 140px;
  border-radius: 999px;
}

.sk-form { padding: 0 8px 40px; }
.sk-input {
  height: 44px;
  border-radius: 12px;
  margin: 14px 0;
}
</style>